// ** IMPORTANT **: Keep in sync with functions/src/index.ts
// ** IMPORTANT **: Make sure public/robots.txt and src/generate-sitemap.ts are updated with route changes
export enum PAGE_ROUTE {
    authAction = 'auth/action',
    about = 'about',
    // ** IMPORTANT **: Keep in sync with functions/src/index.ts/dynamicMetaTags (regex)
    book = 'book',
    physicalBook = 'physical-book',
    characters = 'team',
    // ** IMPORTANT **: Keep in sync with functions/src/index.ts/dynamicMetaTags (regex)
    treasureChest = 'chest',
    socialEmergence = 'social-emergence',
    unsubscribe = 'unsubscribe',
    unsubscribeResult = 'unsubscribed',
    verify = 'verify',
    verifyResult = 'verified',
    cart = 'cart',
    checkout = 'checkout',
    privacyPolicy = 'privacy',
    termsOfUse = 'terms',
    landing = '',
}
